// src/pages/IslamicTrade.js
import React from "react";
import "./IslamicTrade.css"; // Import the CSS file
import { Link } from "react-router-dom";

function IslamicTrade() {
  return (
    <div className="container">
      <h1>Islamic Jurisprudence on Trade (Fiqh al-Buyūʿ)</h1>
      <h2>Introduction</h2>
      <p className="content">
        Islamic Jurisprudence on Trade (Fiqh al-Buyuʿ), refers to the body of
        Islamic legal rulings and ethical guidelines that govern commercial
        transactions. The principles of trade in Islam are rooted in the Qur'an
        and the Sunnah (the practices and sayings of the Prophet Muhammad, peace
        and blessings be upon him), with additional guidance from Islamic
        scholars (fuqaha) who interpret and apply these sources. This area of
        fiqh is part of a broader field called Mu’amalat (transactions), and it
        encompasses a range of subjects, including sales, contracts,
        partnerships, and investments, ensuring that economic activities remain
        ethical, equitable, and aligned with the values of Islamic law. The
        central goal of Fiqh al-Bayʿ(singular) is to promote justice and
        integrity in commerce, protect the interests of all parties involved,
        and create a balanced and ethical economy. The term bayʿ means "to buy
        and sell" or "exchange," and the word itself captures the concept of a
        fair and consensual trade, which Islam upholds as the backbone of
        economic justice.
      </p>
      <h2>Significance</h2>
      <p className="content">
        The significance of Fiqh al-Buyūʿ extends beyond the personal
        acquisition of wealth, as it promotes a broader ethical economy where
        fairness, honesty, and social justice are paramount. Key benefits
        include: Establishing Trust in Society: Islamic trade principles foster
        trust between parties, as honesty and transparency are highly valued.
        Business dealings done with integrity strengthen societal bonds and
        promote mutual respect. Encouraging Fair Distribution of Wealth: Islam
        encourages economic justice, discouraging practices that lead to
        monopolies or wealth concentration in the hands of a few. By prohibiting
        riba and speculative transactions, Fiqh al-Buyūʿ seeks to prevent
        exploitation and ensure wealth circulation. Supporting Financial
        Stability: The avoidance of excessive uncertainty and speculation is
        intended to create stability in economic transactions, as these
        practices often lead to financial crises and societal harm. Stability in
        commerce helps to secure the financial well-being of the community.
        Protecting Individual Rights: Islamic jurisprudence emphasizes the
        importance of contractual fairness, ensuring that both parties
        understand and agree to the terms of a trade. This protects individuals
        from deceit and exploitation. In sum, Fiqh al-Buyūʿ underscores the
        ethical dimensions of economic activity, where each transaction is an
        opportunity for Muslims to practice their faith. By following these
        guidelines, trade becomes an act of worship, aligning the pursuit of
        livelihood with the values of Islam and contributing to a just and
        prosperous society.
      </p>
      <h2>Source</h2>
      <p className="content">
        This module is primarily based on the reputed book{" "}
        <em>Zād al-Mustaqniʿ fī Ikhtiṣār al-Muqniʿ </em> authored by the scholar
        Imam Musa al-Hajjawi (d. 968 AH/1561 CE). This work is known for its
        clarity and brevity, making it a foundational text in Hanbali fiqh
        studied by students and scholars for centuries.
      </p>

      <div className="button-container">
        <a href="/">
          <button className="page-button">Prev</button>
        </a>
        <Link to="/islamic-trade-page-1">
          <button className="page-button">Start</button>
        </Link>
      </div>
    </div>
  );
}

export default IslamicTrade;
